import { emptyFilesListText } from 'owa-locstrings/lib/strings/emptyfileslisttext.locstring.json';
import loc from 'owa-localize';
import {
    DetailsLayout,
    TilesLayout,
    CompactDetailsLayout,
    ItemCacheProvider,
    ItemsScope,
    ItemsView,
    defaultClickActionControl,
    itemsContextMenuControl,
    ControlHandlerProvider,
    IItemCache,
    getItemsScope,
    selectedItemsFacet,
    itemTileControl,
    emptyFolderControl,
} from '@ms/items-view';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { getParameterStore } from '../store/ParametersStore';
import { itemCacheStore, getItemScopeItemKey } from '../store/cache';
import { getColumns } from '../utils/getColumns';
import { defaultClickActionControlHandler } from '../handlers/defaultClickHandler';
import { openInNewTabCommand, downloadCommand, printCommand } from '../utils/getCommandBarActions';
import { fileKeyFacet } from '../Schema/Facets';
import { AttachmentModel } from 'owa-attachment-full-view';
import { getAttachment } from 'owa-attachment-model-store/lib/lazyIndex';
import { TypeOfAttachment } from 'owa-attachment-model-store';

import { IEmptyFolderStyles } from '@ms/items-view/lib/private/components/itemsEmptyFolder/EmptyFolder.styles';

const styles = require('./FilesViewList.scss');

export const FilesViewList = observer(function FilesViewList(props: {}) {
    const parameterStore = getParameterStore();

    return (
        <div className={styles.wrapper}>
            <ItemCacheProvider
                store={itemCacheStore}
                key={`${parameterStore.mailboxInfo &&
                    parameterStore.mailboxInfo.deprecatedMailboxId}-list`}>
                <ItemsScope itemsScopeItemKey={getItemScopeItemKey()}>
                    <ControlHandlerProvider
                        controlHandlers={{
                            ...defaultClickActionControl.pack(defaultClickActionControlHandler),
                            ...itemsContextMenuControl.pack(itemsContextMenuControlHandler),
                            ...itemTileControl.pack(itemTileControlHandler),
                            ...emptyFolderControl.pack(emptyFolderControlHandler),
                        }}>
                        <ItemsView>
                            <DetailsLayout className={styles.detailsList} columns={getColumns()} />
                            <TilesLayout className={styles.detailsList} />
                            <CompactDetailsLayout isAvailable={false} />
                        </ItemsView>
                    </ControlHandlerProvider>
                </ItemsScope>
            </ItemCacheProvider>
        </div>
    );
});

function itemsContextMenuControlHandler(
    itemCache: IItemCache,
    props: typeof itemsContextMenuControl.inputType
): typeof itemsContextMenuControl.returnType {
    const { itemsScopeItemKey } = getItemsScope(itemCache);

    const selectedItems = itemCache.demandItemFacet(selectedItemsFacet, itemsScopeItemKey);
    const selectedItemKeys = selectedItems && selectedItems.itemKeys;
    const hasSelection = selectedItemKeys && selectedItemKeys.length > 0;

    const parameterStore = getParameterStore();

    if (hasSelection) {
        for (const itemKey of selectedItemKeys) {
            const { id } = itemCache.demandItemFacet(fileKeyFacet, itemKey);
            const attachmentId = {
                Id: id,
                mailboxInfo: parameterStore.mailboxInfo,
            };
            const attachment: AttachmentModel = getAttachment(attachmentId);
            if (attachment.type === TypeOfAttachment.Link) {
                return {
                    commands: [openInNewTabCommand],
                };
            }
        }
    }

    return {
        commands: [downloadCommand, printCommand],
    };
}

function itemTileControlHandler(
    itemCache: IItemCache,
    props: typeof itemTileControl.inputType
): typeof itemTileControl.returnType {
    const { itemKey } = props;

    return {
        //TODO localize
        itemActivity: (
            <div>{`Sent by ${itemCache.demandItemFacet(fileKeyFacet, itemKey).sender}`}</div>
        ),
    };
}

function emptyFolderControlHandler(
    itemCache: IItemCache,
    props: typeof emptyFolderControl.inputType
): typeof emptyFolderControl.returnType {
    return {
        emptyFolderIconUrl: require('owa-empty-state/lib/svg/colored/files.svg'),
        emptyFolderTitle: loc(emptyFilesListText),
        getStyles: getEmptyFolderOverrideStyle,
    };
}

function getEmptyFolderOverrideStyle(): Partial<IEmptyFolderStyles> {
    return {
        emptyFolderImageContainer: {
            height: '150px',
            width: '150px',
        },
    };
}
